"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var braintree_web_1 = __importDefault(require("braintree-web"));
var React = __importStar(require("react"));
var react_1 = require("react");
var react_query_1 = require("react-query");
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
var error_message_1 = __importDefault(require("../../../components/error_message"));
var save_button_1 = require("../../../components/save_button");
var update_credit_card_1 = require("../../../mutations/update-credit-card");
var billing_address_1 = __importDefault(require("./billing-address"));
var payment_1 = require("./payment");
exports.default = (function () {
    var context = (0, react_1.useContext)(payment_1.PaymentContext);
    var firstName = context.firstName, lastName = context.lastName, company = context.company, phone = context.phone, address1 = context.address1, address2 = context.address2, city = context.city, province = context.province, zip = context.zip;
    var _a = __read((0, react_1.useState)(null), 2), ccNumberError = _a[0], setCCNumberError = _a[1];
    var _b = __read((0, react_1.useState)(null), 2), ccExpiryError = _b[0], setCCExpiryError = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), ccCVCError = _c[0], setCVCError = _c[1];
    var _d = __read((0, react_1.useState)(), 2), error = _d[0], setError = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), isLoading = _e[0], setLoading = _e[1];
    var queryClient = (0, react_query_1.useQueryClient)();
    var callout = (0, callout_1.useCallout)().callout;
    var updateCreditCard = (0, react_query_1.useMutation)(function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_credit_card_1.UPDATE_CREDIT_CARD, variables); }, {
        onSuccess: function (newData) {
            queryClient.setQueryData('getCustomerSubscriptions', function (oldData) {
                // update the customer cache in place w/o needing to  invalidate the entire cache
                return (0, update_credit_card_1.createSubDataFromUpdates)(oldData, {
                    firstName: firstName,
                    lastName: lastName,
                    address1: address1,
                    address2: address2,
                    zip: zip,
                    city: city,
                    company: company,
                    state: province,
                    phone: phone,
                    brand: newData.updateCreditCard.brand,
                    last4: newData.updateCreditCard.last4,
                    exp_month: newData.updateCreditCard.exp_month,
                    exp_year: newData.updateCreditCard.exp_year,
                    id: newData.updateCreditCard.id,
                });
            });
            window.location.href = '/account/#payment';
            callout.success('Updated Payment!');
        },
        onError: function (error) {
            console.log('error', error);
            setError('There was an error adding the payment method. Please check the information you are trying to input');
        },
    }).mutateAsync;
    var _f = __read((0, react_1.useState)(), 2), braintreeHostedFieldsInstance = _f[0], setBTInstance = _f[1];
    var tokenizeBraintree = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!braintreeHostedFieldsInstance) {
                        throw new Error('braintreeHostedFieldsInstance is not set.');
                    }
                    return [4 /*yield*/, braintreeHostedFieldsInstance.tokenize()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var onFieldValidityChange = function (event) {
        if (event.fields.number && !event.fields.number.isEmpty && !event.fields.number.isValid)
            setCCNumberError('Invalid');
        else
            setCCNumberError(null);
        if (event.fields.expirationDate && !event.fields.expirationDate.isEmpty && !event.fields.expirationDate.isValid)
            setCCExpiryError('Invalid');
        else
            setCCExpiryError(null);
        if (event.fields.cvv && !event.fields.cvv.isEmpty && !event.fields.cvv.isValid)
            setCVCError('Invalid');
        else
            setCVCError(null);
    };
    var onClientInstanceReady = function (clientInstance) {
        braintree_web_1.default.hostedFields
            .create({
            client: clientInstance,
            styles: {
                input: { 'font-size': '16px', 'font-family': '"Oakes Grotesk", sans-serif' },
                ':focus': {
                    borderBottom: '1px solid #8a8a8a',
                },
                '::placeholder': {
                    color: '#c3c3c3',
                },
            },
            fields: {
                number: {
                    selector: '#bt-hosted-field-number',
                    placeholder: 'Credit Card Number',
                },
                cvv: {
                    selector: '#bt-hosted-field-cvv',
                    placeholder: 'CVV',
                },
                expirationDate: {
                    selector: '#bt-hosted-field-expiry-date',
                    placeholder: 'Expiration Date',
                },
            },
        })
            .catch(function (reason) {
            console.error('creating braintree fields failed with', reason);
            setError('There was an error setting up the payment fields');
            throw new Error("creating braintree fields failed with ".concat(reason));
        })
            .then(function (instance) {
            if (instance) {
                setError(null);
                instance.on('validityChange', onFieldValidityChange);
                setBTInstance(instance);
            }
        });
    };
    (0, react_1.useEffect)(function () {
        braintree_web_1.default.client
            .create({ authorization: window.accountApp.braintreeTokenizationKey })
            .then(function (clientInstance) {
            onClientInstanceReady(clientInstance);
        })
            .catch(function (reason) {
            setError('There was an error setting up the payment fields');
            console.error('Error creating Braintree client instance', reason);
        });
    }, []);
    var onSubmitPayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var btToken, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    setLoading(true);
                    return [4 /*yield*/, tokenizeBraintree()];
                case 1:
                    btToken = _a.sent();
                    return [4 /*yield*/, updateCreditCard({
                            token: btToken.nonce,
                            state: province,
                            firstName: firstName,
                            lastName: lastName,
                            company: company,
                            address1: address1,
                            address2: address2,
                            city: city,
                            zip: zip,
                            phone: phone,
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    setError('There was an error adding the payment method. Please check the information you are trying to input');
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: 'margin-vertical-8 account-container' },
        React.createElement("div", { className: 'panel' },
            React.createElement("div", { style: { display: 'block' } },
                React.createElement("div", { className: 'h6' }, "Credit Card"),
                React.createElement("img", { className: 'padding-right-3', style: { height: '38px' }, src: window.accountApp.iconUrls.visa }),
                React.createElement("img", { className: 'padding-right-3', style: { height: '38px' }, src: window.accountApp.iconUrls.masterCard }),
                React.createElement("img", { className: 'padding-right-3', style: { height: '38px' }, src: window.accountApp.iconUrls.discover }),
                React.createElement("img", { className: 'padding-right-3', style: { height: '38px' }, src: window.accountApp.iconUrls.amex }),
                React.createElement("div", { className: 'account-card' },
                    error && React.createElement(error_message_1.default, { error: { message: error } }),
                    React.createElement("div", { className: 'account-input braintree-field cc-number', id: 'bt-hosted-field-number' }),
                    ccNumberError && React.createElement(error_message_1.default, { error: { message: ccNumberError } }),
                    React.createElement("div", { className: 'account-input braintree-field', id: 'bt-hosted-field-expiry-date' }),
                    ccExpiryError && React.createElement(error_message_1.default, { error: { message: ccExpiryError } }),
                    React.createElement("div", { className: 'account-input braintree-field', id: 'bt-hosted-field-cvv' }),
                    ccCVCError && React.createElement(error_message_1.default, { error: { message: ccCVCError } }))),
            React.createElement("div", { style: { display: 'block' } },
                React.createElement(billing_address_1.default, null)),
            React.createElement("div", null,
                React.createElement(save_button_1.SaveButton, { isLoading: isLoading, onClick: onSubmitPayment })))));
});
